import React, { Component } from 'react';

export default class NotFound extends Component {
    render() {
        return (
            <div style={{ textAlign: 'center' }}>
                <h2 style={{ fontSize: '50px' }}>404</h2>
                <p style={{ fontSize: '20px' }}>Vi kunde tyvärr inte hitta det du letade efter.</p>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/components/404.js